import React, { Component } from 'react'
import { BrowserRouter } from 'react-router-dom'
import ReactCSSTransitionGroup from 'react-transition-group/CSSTransition'
import {
  getWidgetSettings,
  getPersistentMenuApi,
  getGreetingText,
  sendSentGreeting,
  sendOpenedGreeting,
  sendAction,
} from '../api/api'
import StartPopup from '../components/startPopup/StartPopup'
import Container from '../components/containers/Container/Container'
import StartScreen from '../components/containers/StartScreen/StartScreen'
import {
  checkIsRightButtonNeeded,
  fullScreenWidth,
  fullScreenHeight,
  startWidth,
  startHeight,
  transitionSettingsContainer,
  transitionSettingsLauncher,
  detectSiteLanguageOrDefault,
  checkWidgetSize,
} from './config'
import widgetStorage from '../actions/storage'
import { generaneUuid } from '../helper/generaneUuid'

import { EndConversationModalProvider } from '../components/EndConversationModal/context'
import { CountUnreadMessagesProvider } from '../components/LaunchButton/CountUnreadMessages/context'
import { FeedbackModalProvider } from '../components/FeedbackModal/context'

import { setAPIUrl } from '../config/config'
import { WebSocketsProviders } from '../integrations/WebSocketsProviders'
import { getUserInfoRequest } from '../api/websocketApi'
import { LaunchButton } from '../components/LaunchButton'

import classes from './styles.module.scss'
import './App.css'

class App extends Component {
  constructor(props) {
    super(props)
    this.myRef = React.createRef()

    this.state = {
      user: null,
      init: false,
      messages: [],
      firstUnreadMessageId: null,
      uuid: generaneUuid(),
      settings: {},
      mobile: false,
      showPopup: false,
      connected: false,
      authorized: false,
      openWidget: false,
      isHiddenWidget: false,
      parentOrigin: null,
      parentURL: false,
      operatorName: null,
      websiteLocation: '',
      settingsUpdated: false,
      showStartScreen: false,
      isFullScreenWidget: false,
      filesForUpload: [],
      language: 'en',
      greeting: null,
      device: {
        width: 0,
        height: 0,
      },
      textDisabled: true,
      popupWasShown: false,
    }
  }

  componentDidMount() {
    const isOpen = widgetStorage.isWidgetOpened()

    this.setState(
      {
        isHiddenWidget: !isOpen,
      },
      () => {
        window.addEventListener('message', this.messageEventListener.bind(this))
        this.initializeWidget()
      },
    )
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      parentOrigin,
      init,
      settingsUpdated,
      showPopup,
      openWidget,
      showStartScreen,
    } = this.state

    const isShouldFrameResize =
      showPopup !== prevState.showPopup ||
      openWidget !== prevState.openWidget ||
      showStartScreen !== prevState.showStartScreen
    const { botId } = this.state
    const chatId = widgetStorage.tryFindChatIdInAnyStorage()

    if (isShouldFrameResize) {
      const widgetOffsetWidth = this.myRef.current.offsetWidth + 'px'
      const widgetOffsetHeight = this.myRef.current.offsetHeight + 'px'

      this.setFrameSize(widgetOffsetWidth, widgetOffsetHeight)
    }

    if (parentOrigin && !init && settingsUpdated) {
      this.initialFunction()
    }

    if (showPopup !== prevState.showPopup && chatId) {
      const actionType = showPopup ? 'pop_up_seen' : 'pop_up_close'
      sendAction(actionType, botId, chatId)
    }

    if (openWidget !== prevState.openWidget && chatId) {
      const actionType = openWidget ? 'widget_open' : 'widget_close'
      sendAction(actionType, botId, chatId)
    }

    if (
      showStartScreen !== prevState.showStartScreen &&
      showStartScreen &&
      chatId
    ) {
      sendAction('welcome_screen_open', botId, chatId)
    }
  }

  initializeWidget() {
    window.parent.postMessage(
      //NOSONAR
      {
        type: 'widget-set-url',
      },
      '*',
    )
  }

  initialFunction() {
    const { settings, isMobile } = this.state
    const chatId = widgetStorage.tryFindChatIdInAnyStorage()
    if (chatId) {
      getUserInfoRequest({
        id: chatId,
        chatId: chatId,
        botId: this.state.botId,
      }).then(response => {
        if (response?.isResetChat) {
          this.resetChat()
        } else if (response?.operatorName) {
          this.setOperatorName(response.operatorName)
        }
      })
    }
    const isOpen = widgetStorage.isWidgetOpened()
    const needUserInformation =
      settings.isLoginEmailInputEnabled || settings.isLoginNameInputEnabled
    const authorized =
      !needUserInformation || (chatId && widgetStorage.isEnabled())

    if (isOpen !== null && chatId !== null) {
      setTimeout(() => {
        this.toggleBackground(isOpen)
        this.setState({ openWidget: isOpen, isHiddenWidget: !isOpen })
      }, 100)
    }

    if (window.location.search.includes('open=true') && !needUserInformation) {
      this.setState(
        {
          isFullScreenWidget: !isMobile,
          openWidget: true,
          init: true,
          authorized,
        },
        () => this.resizeWidget(!isMobile),
      )
    } else if (this.state.greeting) {
      const popupDelayTimeout = setTimeout(() => {
        if (!this.state.openWidget) {
          this.setState({ showPopup: true, popupWasShow: true }, () => {
            const chatId = widgetStorage.tryFindChatIdInAnyStorage()
            sendSentGreeting(this.state.botId, this.state.greeting.hash, chatId)
          })
        }
      }, this.state.greeting.delaySeconds * 1000)
      this.setState({
        init: true,
        authorized,
        popupDelayTimeout,
      })
    } else {
      this.setState({
        init: true,
        authorized,
      })
    }
  }

  setLanguage = language => {
    this.setState({
      language: language,
    })
  }

  setFirstUnreadMessageId = message => {
    this.setState({
      firstUnreadMessageId: message,
    })
  }

  messageEventListener(event) {
    if (event.data.type === 'widget' && event.data.uuid === this.state.uuid) {
      this.widgetEventListener(event)
    }

    if (
      event.data.type === 'initialization' &&
      event.data.uuid === this.state.uuid
    ) {
      this.configureWidget(event)
    }

    if (event.data.type === 'page-url-changed') {
      this.pageUrlListener(event)
    }

    if (event.data.type === 'reset-chat-history') {
      this.resetChat()
    }

    if (event.data.type === 'open-widget-bot') {
      if (!this.state.authorized && event.data.userName) {
        const user = {
          ...this.state.user,
          name: event.data.userName,
        }
        this.updateUserData(user)
      } else {
        this.toggleWidget()
      }
    }
  }

  configureWidget = event => {
    setAPIUrl(event.data.serverUrl)
    this.setUserLanguage()
    this.setWidget(event.data)
  }

  resetChat = () => {
    this.setState(
      {
        chatId: null,
        openWidget: false,
        authorized: false,
        showStartScreen: false,
        user: null,
        messages: [],
      },
      () => widgetStorage.clearStorage(this.state.botId),
    )
  }

  widgetEventListener = event => {
    let { parentOrigin, isMobile, device, chatId, parentURL } = this.state
    if (event.data.isMobile) {
      isMobile = event.data.isMobile
      device = {
        width: event.data.device.width,
        height: event.data.device.height,
      }
    }
    if (!this.state.chatId && widgetStorage.tryFindChatIdInAnyStorage()) {
      chatId = widgetStorage.tryFindChatIdInAnyStorage()
    }
    if (event.origin !== parentOrigin) {
      parentOrigin = event.origin || document.location.origin
    }
    if (parentURL !== event.data.parentURL) {
      parentURL = event.data.parentURL
    }

    this.setState({
      device,
      chatId,
      isMobile,
      parentURL,
      parentOrigin,
    })
  }

  pageUrlListener = event => {
    window.parent.postMessage(
      {
        width: startWidth,
        height: startHeight,
        needId: true,
        initialization: true,
        type: 'widget',
        uuid: this.state.uuid,
      },
      event.data.url,
    )

    const language = detectSiteLanguageOrDefault(this.state.websiteLocation)
    setAPIUrl(event.data.serverUrl)
    this.setState(
      {
        websiteLocation: event.data.url,
      },
      () => {
        if (this.state.greeting) {
          getGreetingText(
            event.data.botId,
            event.data.attributes,
            language,
          ).then(greeting => {
            this.setState({
              websiteLocation: event.data.url,
              greeting,
            })
          })
        }
      },
    )
  }

  handleConnect = connected => {
    this.setState({ connected })
  }

  setFrameSize(newWidth, newHeight) {
    const { showStartScreen, isMobile, parentOrigin } = this.state

    window.parent.postMessage(
      {
        type: 'widget',
        uuid: this.state.uuid,
        width: newWidth,
        height: newHeight,
        needDelay: showStartScreen && isMobile,
      },
      parentOrigin,
    )
  }

  setWidget = async data => {
    if (!data.botId) {
      return
    }

    const language = detectSiteLanguageOrDefault(this.state.websiteLocation)
    widgetStorage.configureBotId(data.botId)
    const chatId = widgetStorage.tryFindChatIdInAnyStorage()
    const settings = await getWidgetSettings(data.botId, chatId, language)

    if (!settings) return

    widgetStorage.configure(settings.chatHistoryLevel, data.botId)

    if (!widgetStorage.tryFindChatIdInAnyStorage()) {
      this.setInputField(settings.isComposerInputEnabled)
    }

    widgetStorage.setChatId(chatId)

    const greeting = await getGreetingText(
      data.botId,
      data.attributes,
      language,
    )

    this.setState({
      language,
      greeting,
      settings,
      botId: data.botId,
      settingsUpdated: true,
      attributes: data.attributes,
    })
  }

  updateWidget = (botId, language) => {
    getWidgetSettings(botId, null, language).then(settings => {
      if (!settings) return
      this.setState({
        settings,
      })
    })
  }

  setPersistentMenu = (botId, chatId) => {
    if (botId && chatId) {
      getPersistentMenuApi(botId, chatId)
        .then(persistentMenu => {
          this.setState({ persistentMenu })
        })
        .catch(console.error)
    }
  }

  setInputField = textDisabled => {
    if (this.state.textDisabled !== textDisabled) {
      this.setState({ textDisabled })
    }
  }

  setOperatorName = operatorName => {
    this.setState({
      operatorName,
    })
  }

  openStartScreen = () => {
    widgetStorage.setIsWidgetOpened(false)
    this.toggleBackground(false)
    this.setState({
      showStartScreen: true,
      showPopup: false,
    })
  }
  hideStartScreen = () => {
    this.setState({ showStartScreen: false })
  }

  toggleAuthorized = () => {
    this.setState(
      {
        showPopup: false,
        openWidget: !this.state.openWidget,
        messages: [],
      },
      () => {
        if (this.state.isFullScreenWidget) {
          this.resizeWidget(false)
        }
        this.toggleBackground(this.state.openWidget)
        widgetStorage.setIsWidgetOpened(this.state.openWidget)
      },
    )
  }

  handleHiddenWidget = () => {
    this.setState(
      {
        isHiddenWidget: true,
      },
      () => {
        this.toggleWidget()
      },
    )
  }

  handleViewWidget = () => {
    this.setState(
      {
        isHiddenWidget: false,
      },
      () => {
        this.toggleWidget()
      },
    )
  }

  toggleUnauthorized = () => {
    const { showStartScreen } = this.state
    if (showStartScreen) {
      this.hideStartScreen()
    } else {
      widgetStorage.setIsWidgetOpened(false)
      this.toggleBackground(false)
      this.openStartScreen()
    }
  }

  resizeWidget = isFullScreenWidget => {
    const widgetOffsetWidth = this.myRef.current.offsetWidth + 'px'
    const widgetOffsetHeight = this.myRef.current.offsetHeight + 'px'
    const width = isFullScreenWidget ? fullScreenWidth : widgetOffsetWidth
    const height = isFullScreenWidget ? fullScreenHeight : widgetOffsetHeight

    this.setState(
      {
        width,
        height,
        isFullScreenWidget,
      },
      () => {
        window.parent.postMessage(
          {
            type: 'widget',
            width,
            height,
            uuid: this.state.uuid,
            isFullScreenWidget: this.state.isFullScreenWidget,
          },
          this.state.parentOrigin,
        )
      },
    )
  }
  toggleWidget = () => {
    const { authorized, settings, popupDelayTimeout } = this.state
    clearTimeout(popupDelayTimeout)

    widgetStorage.setIsWidgetOpenedIfNull(true)

    const needUserInformation =
      settings.isLoginNameInputEnabled || settings.isLoginEmailInputEnabled
    if (needUserInformation && !authorized) {
      this.toggleUnauthorized()
    } else {
      this.toggleAuthorized()
    }
  }

  getAttachmentFiles = e => {
    this.setState({
      filesForUpload: Array.from(e.target.files),
    })
  }

  resetAttachmentFiles = () => {
    this.setState({
      filesForUpload: [],
    })
    this.attachmentInput.value = ''
  }

  toggleBackground = isBackgroundEnable => {
    const { settings } = this.state
    if (!settings.isBackgroundBlurred) return
    if (!isBackgroundEnable && widgetStorage.isEnabled()) {
      this.setState({ messages: [] })
    }

    window.parent.postMessage(
      {
        type: 'widget-background',
        background: isBackgroundEnable,
      },
      this.state.parentOrigin,
    )
  }
  closeWidget = () => {
    this.setState(
      {
        openWidget: false,
        messages: this.state.isDisplayChatHistory ? [] : this.state.messages,
      },
      () => {
        this.toggleBackground(this.state.openWidget)
        widgetStorage.setIsWidgetOpened(this.state.openWidget)
        if (this.state.isFullScreenWidget) {
          this.resizeWidget(false)
        }
      },
    )
  }

  updateMessages = (newMessages, callback, isOldMessages) => {
    if (newMessages && newMessages.length > 0) {
      if (isOldMessages) {
        return this.setState(
          prevState => ({ messages: newMessages.concat(prevState.messages) }),
          () => {
            if (callback) callback()
          },
        )
      }
      return this.setState(
        prevState => ({ messages: prevState.messages.concat(newMessages) }),
        () => {
          if (callback) callback()
        },
      )
    }
  }

  clearUserData = () => {
    this.setState(
      {
        user: null,
        showStartScreen: false,
        openWidget: false,
        authorized: false,
        messages: [],
      },
      () => {
        widgetStorage.setIsWidgetOpened(false)
        this.toggleBackground(false)
      },
    )
  }

  updateUserData = user => {
    user.language = detectSiteLanguageOrDefault(this.state.websiteLocation)
    this.setState(
      {
        user,
        showStartScreen: false,
        openWidget: true,
        authorized: true,
      },
      () => {
        widgetStorage.setIsWidgetOpened(true)
        this.toggleBackground(true)
      },
    )
  }

  setUserLanguage = () => {
    const language = detectSiteLanguageOrDefault(this.state.websiteLocation)

    if (this.state.user === null) {
      this.setState({
        user: {
          language,
        },
      })
    }
  }

  submitPopup = () => {
    this.setState(
      {
        showPopup: false,
      },
      () => {
        const chatId = widgetStorage.tryFindChatIdInAnyStorage()
        sendOpenedGreeting(this.state.botId, this.state.greeting.hash, chatId)
        this.toggleWidget()
      },
    )
  }
  closePopup = () => {
    this.setState({ showPopup: false })
  }

  updateGreeting = greeting => {
    this.setState({ greeting })
  }

  openUrl = url => {
    window.parent.postMessage(
      {
        type: 'open-url',
        url: url,
        uuid: this.state.uuid,
      },
      '*',
    )
  }

  render() {
    const {
      init,
      user,
      botId,
      device,
      isMobile,
      messages,
      settings,
      greeting,
      parentURL,
      showPopup,
      openWidget,
      connected,
      authorized,
      attributes,
      parentOrigin,
      textDisabled,
      isHiddenWidget,
      operatorName,
      filesForUpload,
      websiteLocation,
      settingsUpdated,
      showStartScreen,
      firstUnreadMessageId,
      isFullScreenWidget,
      persistentMenu,
      popupWasShow,
      language,
    } = this.state

    const isWidgetOpened = !authorized ? !showStartScreen : !openWidget
    const isStartPopupNeeded =
      init && showPopup && !showStartScreen && !openWidget
    const isButtonNeeded = checkIsRightButtonNeeded(
      device,
      openWidget,
      isFullScreenWidget,
    )

    return (
      <>
        {settingsUpdated && (
          <div
            ref={this.myRef}
            className={checkWidgetSize(classes, isFullScreenWidget)}>
            <BrowserRouter basename="/">
              <EndConversationModalProvider>
                <FeedbackModalProvider botId={botId}>
                  <CountUnreadMessagesProvider>
                    <WebSocketsProviders
                      user={user}
                      botId={botId}
                      language={language}
                      greeting={greeting}
                      showPopup={showPopup}
                      messages={messages}
                      attributes={attributes}
                      popupWasShow={popupWasShow}
                      openWidget={openWidget}
                      parentOrigin={parentOrigin}
                      websiteLocation={websiteLocation}
                      updateGreeting={this.updateGreeting}
                      setPersistentMenu={this.setPersistentMenu}
                      updateWidget={this.updateWidget}
                      onConnect={this.handleConnect}
                      closeWidget={this.closeWidget}
                      setInputField={this.setInputField}
                      updateMessages={this.updateMessages}
                      isDisplayChatHistory={settings.chatHistoryLevel}
                      connected={connected}
                      isHiddenWidget={isHiddenWidget}
                      openUrl={this.openUrl}
                      resetChat={this.resetChat}
                      clearUserData={this.clearUserData}
                      setOperatorName={this.setOperatorName}
                      handleNotHiddenWidget={this.handleNotHiddenWidget}
                      firstUnreadMessageId={firstUnreadMessageId}
                      setLanguage={this.setLanguage}
                      setFirstUnreadMessageId={this.setFirstUnreadMessageId}>
                      {openWidget && (
                        <ReactCSSTransitionGroup
                          {...transitionSettingsContainer}>
                          <>
                            <Container
                              botId={botId}
                              language={language}
                              persistentMenu={persistentMenu}
                              device={device}
                              isMobile={isMobile}
                              messages={messages}
                              settings={settings}
                              parentURL={parentURL}
                              textDisabled={textDisabled}
                              resizeWidget={this.resizeWidget}
                              toggleWidget={this.toggleWidget}
                              updateMessages={this.updateMessages}
                              isFullScreenWidget={isFullScreenWidget}
                              operatorName={operatorName}
                              filesForUpload={filesForUpload}
                              handleHiddenWidget={this.handleHiddenWidget}
                              resetAttachmentFiles={this.resetAttachmentFiles}
                              setFirstUnreadMessageId={
                                this.setFirstUnreadMessageId
                              }
                              firstUnreadMessageId={firstUnreadMessageId}
                            />
                            <input
                              multiple
                              id="attachment-files"
                              type="file"
                              style={{ display: 'none' }}
                              ref={input => (this.attachmentInput = input)}
                              accept="video/*, image/*"
                              onChange={this.getAttachmentFiles}
                            />
                          </>
                        </ReactCSSTransitionGroup>
                      )}
                      {showStartScreen && (
                        <StartScreen
                          authorized={authorized}
                          greeting={greeting}
                          showPopup={showPopup}
                          popupWasShow={popupWasShow}
                          device={device}
                          settings={settings}
                          toggleWidget={this.toggleWidget}
                          updateUserData={this.updateUserData}
                        />
                      )}
                      <ReactCSSTransitionGroup {...transitionSettingsLauncher}>
                        {isButtonNeeded ? (
                          <div className={classes.rightBottomPositioned}>
                            {isStartPopupNeeded && (
                              <StartPopup
                                device={device}
                                settings={settings}
                                greeting={greeting}
                                authorized={authorized}
                                showStartScreen={showStartScreen}
                                closePopup={this.closePopup}
                                submitPopup={this.submitPopup}
                              />
                            )}
                            <LaunchButton
                              botId={botId}
                              greeting={greeting}
                              showPopup={showPopup}
                              authorized={authorized}
                              showStartScreen={showStartScreen}
                              settings={settings}
                              isWidgetOpened={isWidgetOpened}
                              isHiddenWidget={isHiddenWidget}
                              toggleWidget={this.toggleWidget}
                              handleViewWidget={this.handleViewWidget}
                            />
                          </div>
                        ) : <div/>}
                      </ReactCSSTransitionGroup>
                    </WebSocketsProviders>
                  </CountUnreadMessagesProvider>
                </FeedbackModalProvider>
              </EndConversationModalProvider>
            </BrowserRouter>
          </div>
        )}
      </>
    )
  }
}

export default App
